import { NgModule } from '@angular/core';
import { RouterModule, PreloadAllModules, Routes } from '@angular/router';
import { BaseRoutes } from '@nts/std';
import { environment } from 'src/environments/environment';
const title = environment ? environment.appTitle : 'Application Title';

const routes: Routes = [
  // #region rotte con autenticazione
  ...BaseRoutes.getBaseAuthentictedRoutes(
    environment,
    [
      ...BaseRoutes.getEntityRoutes(
        title,
        'aiaction',
        () => import('./ai-support/ai-support.module').then(m => m.AiSupportModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'assistantinfo',
        () => import('./assistant-info/assistant-info.module').then(m => m.AssistantInfoModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'knowledgeinfo',
        () => import('./knowledge-info/knowledge-info.module').then(m => m.KnowledgeInfoModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'uploadbusinessdocumentationlongop',
        () => import('./upload-business-documentation-long-op/upload-business-documentation-long-op.module').then(m => m.UploadBusinessDocumentationLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'userfeedbacklistlongop',
        () => import('./user-feedback-list-long-op/user-feedback-list-long-op.module').then(m => m.UserFeedbackListLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'updateuserfeedbacklongop',
        () => import('./update-user-feedback-long-op/update-user-feedback-long-op.module').then(m => m.UpdateUserFeedbackLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'finetunedmodel',
        () => import('./fine-tuned-model/fine-tuned-model.module').then(m => m.FineTunedModelModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'createfinetuningfilelongop',
        () => import('./create-fine-tuning-file-long-op/create-fine-tuning-file-long-op.module').then(m => m.CreateFineTuningFileLongOpModule)
      ),

      ...BaseRoutes.getEntityRoutes(
        title,
        'dbschemadefinition',
        () => import('./dbschema-definition/dbschema-definition.module').then(m => m.DBSchemaDefinitionModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'processdbschemalongop',
        () => import('./processdb-schema-long-op/processdb-schema-long-op.module').then(m => m.ProcessDBSchemaLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'aisupportsettings',
        () => import('./aisupport-settings/aisupport-settings.module').then(m => m.AISupportSettingsModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'aiqueryregressiontestlongop',
        () => import('./ai-query-regression-test-long-op/aiquery-regression-test-long-op.module').then(m => m.AIQueryRegressionTestLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'querybyexample',
        () => import('./query-by-example/query-by-example.module').then(m => m.QueryByExampleModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'buildqbedatalongop',
        () => import('./build-qbe-data-long-op/build-qbe-data-long-op.module').then(m => m.BuildQbeDataLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'loadqbexmllongop',
        () => import('./load-qbe-xml-long-op/load-qbe-xml-long-op.module').then(m => m.LoadQbeXmlLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'createairesourceslongop',
        () => import('./create-ai-resources-long-op/create-ai-resources-long-op.module').then(m => m.CreateAIResourcesLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'docsintelligence',
        () => import('./docs-intelligence/docs-intelligence.module').then(m => m.DocsIntelligenceModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'extendedknowledgeinfo',
        () => import('./extended-knowledge-info/extended-knowledge-info.module').then(m => m.ExtendedKnowledgeInfoModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'extendedschemadefinition',
        () => import('./extended-schema-definition/extended-schema-definition.module').then(m => m.ExtendedSchemaDefinitionModule)
      ),
      ...BaseRoutes.getDefaultRoutes(
        title,
        environment,
        true
      )
    ]
  ),
  // #endregion rotte con autenticazione


  // rotte base per la gestione degli errori
  ...BaseRoutes.getBaseErrorsRoute()
];

@NgModule({
  imports: [
    // TODO Tommy: si potrebbe creare una custom preloadin strategy per precaricare solo le rotte offline
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      paramsInheritanceStrategy: 'always',
      preloadingStrategy: PreloadAllModules
    }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
